'use strict';
const ACCEPTED_LAYER_PAGE = 'flexAccept';
const CUSTOMER_SUPPORT_LAYER_PAGE = 'flexSearch';
const ACCEPTED_PAGE_CRL = 'flexAcceptCRL';
const ACCEPTANCE_PAGE_CRL = 'myarflCRL';

module.exports = {
    TRACKING_PARAMS: ['status', 'flex', 'id', 'pag'],
    ONLOAD: {
        EVENT: 'ONLOAD',
        ACTION: 'trip_details',
        PARTIAL: 'message_onload',
        PNR: '',
    },
    OPEN: {
        EVENT: 'OPEN',
        ACTION: 'trip_details',
        PARTIAL: 'acceptance_click',
        PNR: '',
    },
    TERMS_CONDITIONS: {
        EVENT: 'TERMS_CONDITIONS',
        ACTION: 'trip_details',
        PARTIAL: 'conditions_click',
        PNR: '',
    },
    ACCEPT: {
        EVENT: 'ACCEPT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_YES',
        PNR: '',
    },
    REFUND: {
        EVENT: 'REFUND',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_NO',
        PNR: '',
    },
    TICKET_CONDITIONS: {
        EVENT: 'TICKET_CONDITIONS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_terms',
        PNR: '',
    },
    CLOSE_ACCEPTANCE: {
        EVENT: 'CLOSE_ACCEPTANCE',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_close',
        PNR: '',
    },
    OPEN_ACCEPTED_MANAGE_BUTTON: {
        EVENT: 'OPEN_ACCEPTED_MANAGE_BUTTON',
        ACTION: 'trip_details',
        PARTIAL: 'accepted_click',
        PNR: '',
    },
    CLOSE_ACCEPTED: {
        EVENT: 'CLOSE_ACCEPTED',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_back',
        PNR: '',
    },
    ACCEPTED_TICKET_CONDITIONS: {
        EVENT: 'ACCEPTED_TICKET_CONDITIONS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_terms-search',
        PAG: ACCEPTED_LAYER_PAGE,
        PNR: '',
    },
    SEE_AVAILABLE_FLIGHTS: {
        EVENT: 'SEE_AVAILABLE_FLIGHTS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_search',
        PNR: '',
    },
    CLOSE_CUSTOMER_SUPPORT: {
        EVENT: 'CLOSE_CUSTOMER_SUPPORT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_back',
        PNR: '',
    },
    CUSTOMER_SUPPORT_CTA_CALL: {
        EVENT: 'CUSTOMER_SUPPORT_CTA_CALL',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_call',
        PNR: '',
    },
    CUSTOMER_SUPPORT_CTA_BACK: {
        EVENT: 'CUSTOMER_SUPPORT_CTA_BACK',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_trip',
        PNR: '',
    },
    CASH_REFUND_LOAD: {
        EVENT: 'CASH_REFUND_LOAD',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund_layer_onload:link',
        PNR: '',
    },
    CASH_REFUND_LOAD_BACK: {
        EVENT: 'CASH_REFUND_LOAD_BACK',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund_layer_onload:back',
        PNR: '',
    },
    CASH_REFUND_CLOSE: {
        EVENT: 'CASH_REFUND_CLOSE',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund_layer_click:close',
        PNR: '',
    },
    CASH_REFUND_KEEP_ACCEPT_CREDIT: {
        EVENT: 'CASH_REFUND_KEEP_ACCEPT_CREDIT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund_layer_click:flex',
        PNR: '',
    },
    CASH_REFUND_REQUEST_REFUND: {
        EVENT: 'CASH_REFUND_REQUEST_REFUND',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund_layer_click:refund',
        PNR: '',
    },
    EDO_VOUCHER_CONDITIONS: {
        EVENT: 'EDO_VOUCHER_CONDITIONS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_terms-app',
        PAG: ACCEPTED_LAYER_PAGE,
        PNR: '',
    },
    ACCEPTED_OPTIONS_PRIME_BTN: {
        EVENT: 'ACCEPTED_OPTIONS_PRIME_BTN',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'primewidget_click',
        PAG: ACCEPTED_LAYER_PAGE,
        PNR: '',
    },
    OPTIONS_NON_PRIME_LOAD: {
        EVENT: 'OPTIONS_NON_PRIME_LOAD',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'primewidget_onload_activate',
        PAG: ACCEPTED_LAYER_PAGE,
        PNR: '',
    },
    OPTIONS_PRIME_LOAD: {
        EVENT: 'OPTIONS_PRIME_LOAD',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'primewidget_onload_extend',
        PAG: ACCEPTED_LAYER_PAGE,
    },
    ACCEPT_FROM_FOOTER: {
        EVENT: 'ACCEPT_FROM_FOOTER',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_YES-fixed',
        PNR: '',
    },
    OPEN_CREDIT_TCS: {
        EVENT: 'OPEN_CREDIT_TCS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'click-info:credit',
        PNR: '',
    },
    OPEN_CREDIT_TCS_LOAD: {
        EVENT: 'OPEN_CREDIT_TCS_LOAD',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'onload-info:credit',
        PNR: '',
    },
    CLOSE_CREDIT_TCS: {
        EVENT: 'CLOSE_CREDIT_TCS',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'close-info:credit',
        PNR: '',
    },
    APP_SPLASH_LOAD_ACCEPT: {
        EVENT: 'APP_SPLASH_LOAD_ACCEPT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_onload_credit',
        PNR: '',
    },
    APP_SPLASH_LOAD_REJECT: {
        EVENT: 'APP_SPLASH_LOAD_REJECT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_onload_refund',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_ACCEPT_BUTTON: {
        EVENT: 'DOWNLOAD_APP_SPLASH_ACCEPT_BUTTON',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_download_credit-button',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_ACCEPT_PHONE: {
        EVENT: 'DOWNLOAD_APP_SPLASH_ACCEPT_PHONE',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_download_credit-phone',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_REJECT_BUTTON: {
        EVENT: 'DOWNLOAD_APP_SPLASH_REJECT_BUTTON',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_download_refund-button',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_REJECT_PHONE: {
        EVENT: 'DOWNLOAD_APP_SPLASH_REJECT_PHONE',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_download_refund-phone',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_REFUND_BUTTON: {
        EVENT: 'DOWNLOAD_APP_SPLASH_REFUND_BUTTON',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash-button',
        PNR: '',
    },
    DOWNLOAD_APP_SPLASH_REFUND_PHONE: {
        EVENT: 'DOWNLOAD_APP_SPLASH_REFUND_PHONE',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash-phone',
        PNR: '',
    },
    APP_SPLASH_DOWNLOAD_DESKTOP: {
        EVENT: 'APP_SPLASH_DOWNLOAD_DESKTOP',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_app-download',
        PNR: '',
    },
    APP_SPLASH_NA_DESKTOP: {
        EVENT: 'APP_SPLASH_NA_DESKTOP',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_app-NA',
        PNR: '',
    },
    CLOSE_APP_SPLASH_ICON_DESKTOP: {
        EVENT: 'CLOSE_APP_SPLASH_ICON_DESKTOP',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_back',
        PNR: '',
    },
    CLOSE_APP_SPLASH_BG: {
        EVENT: 'CLOSE_APP_SPLASH_BG',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_greyspace',
        PNR: '',
    },
    CLOSE_APP_SPLASH_ACCEPT: {
        EVENT: 'CLOSE_APP_SPLASH_ACCEPT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_close_YES',
        PNR: '',
    },
    CLOSE_APP_SPLASH_REJECT: {
        EVENT: 'CLOSE_APP_SPLASH_REJECT',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash_close_NO',
        PNR: '',
    },
    CLOSE_APP_SPLASH_REFUND: {
        EVENT: 'CLOSE_APP_SPLASH_REFUND',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'appsplash-close',
        PNR: '',
    },
    OPEN_APP_SPLASH_CLICK_BUTTON: {
        EVENT: 'OPEN_APP_SPLASH_CLICK_BUTTON',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund-status-click',
        PNR: '',
    },
    LOAD_OPENTIKCET_REJECTED: {
        EVENT: 'LOAD_OPENTIKCET_REJECTED',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'refund-status-load',
        PNR: '',
    },
    GET_APP: {
        EVENT: 'GET_APP',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'download-app',
        PNR: '',
    },
    FLEXIBLE_STATUS: {
        acceptedPNRs: 'flexTickYES',
        pendingPNRs: 'flexTick',
        rejectedPNRs: 'flexTickNO',
    },
    ACCORDION: {
        terms: 'TICKET_CONDITIONS',
    },
    PAGE: {
        ACCEPTED_LAYER: ACCEPTED_LAYER_PAGE,
        CUSTOMER_SUPPORT_LAYER: CUSTOMER_SUPPORT_LAYER_PAGE,
        ACCEPTED_CRL: ACCEPTED_PAGE_CRL,
        ACCEPTANCE_CRL: ACCEPTANCE_PAGE_CRL,
    },
    OPEN_MOBILE_APP: {
        EVENT: 'OPEN_MOBILE_APP',
        ACTION: 'trip_details_flexible_ticket',
        PARTIAL: 'popup_open-app',
        PNR: '',
    },
    TRACKING_PAGE: {
        ACCEPTANCE: 'tripdetails/flights/open-ticket',
        ACCEPTED: 'tripdetails/flights/open-ticket-accepted',
        CUSTOMER_SUPPORT: 'tripdetails/flights/open-ticket-accepted/available-flights',
        CASH_REFUND_ACCEPTANCE: 'tripdetails/fligths/open-ticket/refund-layer',
        CASH_REFUND_ACCEPTED: 'tripdetails/fligths/open-ticket-accepted/refund-layer',
    },
};
